export const blocHConstants = {
  GET_BLOCH_REQUEST: 'GET_BLOCH_REQUEST',
  GET_BLOCH_SUCCESS: 'GET_BLOCH_SUCCESS',
  GET_BLOCH_FAILURE: 'GET_BLOCH_FAILURE',

  UPDATE_BLOCH_REQUEST: 'UPDATE_BLOCH_REQUEST',
  UPDATE_BLOCH_SUCCESS: 'UPDATE_BLOCH_SUCCESS',
  UPDATE_BLOCH_FAILURE: 'UPDATE_BLOCH_FAILURE',
};
